import { onBeforeUnmount, onMounted, ref } from "vue";

export default function useElementHeight() {
  const elementRef = ref<HTMLElement | null>(null);
  const elementHeight = ref<number>(0);
  let resizeObserver: ResizeObserver | null = null;

  onMounted(() => {
    if (elementRef.value) {
      resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          elementHeight.value = entry.contentRect.height;
        });
      });

      resizeObserver.observe(elementRef.value);
    }
  });

  onBeforeUnmount(() => {
    if (resizeObserver) {
      resizeObserver.disconnect();
    }
  });

  return { elementRef, elementHeight };
}
